module.exports = __webpack_public_path__ + "static/HowWeHelp-9f64a96e6e67d5d27721ccaa3ed8ecec.png";